<div class="vault-overlay">
  <!-- Backdrop -->
  <div class="backdrop" (click)="closeModal()"></div>

  <!-- iOS Style Modal -->
  <div class="vault-modal">
    <!-- Header -->
    <div class="modal-header">
      <h3>Personal Vault Setup</h3>
      <button (click)="closeModal()" class="close-btn">
        <span class="material-symbols-outlined">close</span>
      </button>
    </div>

    <!-- Content Area -->
    <div class="modal-content">
      <!-- Progress Steps -->
      <div class="progress-steps" *ngIf="step !== 'DONE'">
        <div
          class="step-dot"
          [class.active]="step === 'INIT'"
          [class.completed]="step !== 'INIT'"
        ></div>
        <div class="step-line" [class.active]="step !== 'INIT'"></div>
        <div
          class="step-dot"
          [class.active]="step === 'MNEMONIC'"
          [class.completed]="step === 'PIN'"
        ></div>
        <div class="step-line" [class.active]="step === 'PIN'"></div>
        <div class="step-dot" [class.active]="step === 'PIN'"></div>
      </div>

      <!-- Step 1: INIT -->
      <div *ngIf="step === 'INIT' && !isCheckingOrg" class="step-init">
        <div class="icon-wrapper">
          <span class="material-symbols-outlined">lock_open</span>
        </div>

        <div>
          <h2>Secure Your Data</h2>
          <p>
            Create a personal key to encrypt your data.
            <br />Only you will hold the keys.
          </p>
        </div>

        <div class="warning-box">
          <span class="material-symbols-outlined">warning</span>
          <p>
            <strong>Warning:</strong> If you lose your recovery phrase, your
            data is lost forever. We cannot recover it for you.
          </p>
        </div>

        <div class="action-buttons">
          <button
            (click)="generate()"
            class="btn-large-brand"
            *ngIf="isFirstTimeSetup"
          >
            Generate New Vault
          </button>

          <button
            (click)="startImport()"
            class="btn-large-secondary"
            *ngIf="!isFirstTimeSetup"
          >
            I have a Recovery Phrase
          </button>
        </div>
      </div>

      <!-- Loading State -->
      <div
        *ngIf="isCheckingOrg && step === 'INIT'"
        class="loading-state custom-style-90d4de"
        
      >
        <div class="spinner"></div>
        <p class="custom-style-5afab2" >
          Verifying Organization Status...
        </p>
      </div>

      <!-- Step: IMPORT -->
      <div *ngIf="step === 'IMPORT'" class="step-import">
        <div class="instruction-text">
          <h3>Enter Recovery Phrase</h3>
          <p>Enter your 24-word phrase in order.</p>
        </div>

        <div class="import-actions">
          <button
            class="paste-btn"
            (click)="dummyPasteInput.focus(); dummyPasteInput.select()"
          >
            <span class="material-symbols-outlined">content_paste</span>
            Paste Entire Phrase
          </button>
          <!-- Hidden input to capture paste events for the whole phrase -->
          <input
            #dummyPasteInput
            class="sr-only"
            (paste)="handlePaste($event)"
            placeholder="Paste here"
          />
        </div>

        <div class="word-grid editable">
          <div
            *ngFor="
              let word of importMnemonic;
              let i = index;
              trackBy: trackByFn
            "
            class="word-input"
          >
            <span class="index">{{ i + 1 }}</span>
            <input
              [(ngModel)]="importMnemonic[i]"
              type="text"
              autocomplete="off"
              (paste)="handlePaste($event)"
            />
          </div>
        </div>

        <div class="error-msg" *ngIf="importError">
          <span class="error-content">
            <span class="material-symbols-outlined text-sm">error</span>
            {{ importError }}
          </span>
        </div>

        <button
          (click)="validateAndImport()"
          [disabled]="loading"
          class="btn-large-brand"
        >
          <span *ngIf="!loading">Verify & Continue</span>
          <span *ngIf="loading">Verifying...</span>
        </button>
      </div>

      <!-- Step 2: MNEMONIC (Generation) -->
      <div *ngIf="step === 'MNEMONIC'" class="step-mnemonic">
        <div class="instruction-text">
          <h3>Save Recovery Phrase</h3>
          <p>Write these words down or save them securely.</p>
        </div>

        <div class="word-grid">
          <div
            *ngFor="let word of mnemonicWords; let i = index"
            class="word-chip"
          >
            <span class="index">{{ i + 1 }}</span>
            <span class="word">{{ word }}</span>
          </div>
        </div>

        <div class="confirmation-group">
          <div class="download-section">
            <button (click)="downloadRecoveryPhrase()" class="btn-text-icon">
              <span class="material-symbols-outlined">download</span>
              Download Recovery Phrase
            </button>
          </div>

          <label class="confirmation-check">
            <input type="checkbox" [(ngModel)]="hasSaved" />
            <span>I have recorded my 24-word recovery phrase</span>
          </label>

          <button
            [disabled]="!hasSaved"
            (click)="step = 'PIN'"
            class="btn-large-brand"
          >
            Continue
          </button>
        </div>
      </div>

      <!-- Step 3: PIN -->
      <div *ngIf="step === 'PIN'" class="step-pin">
        <div class="pin-header">
          <h3>Create Vault PIN</h3>
          <p>Set a 6-digit PIN to access your vault quickly.</p>
        </div>

        <div class="pin-inputs">
          <input
            type="password"
            [(ngModel)]="pin"
            maxlength="6"
            placeholder="Create PIN"
            autofocus
            autocomplete="off"
          />
          <input
            type="password"
            [(ngModel)]="confirmPin"
            maxlength="6"
            placeholder="Confirm PIN"
            autocomplete="off"
          />
        </div>

        <div class="error-msg">
          <span *ngIf="pinError" class="error-content">
            <span class="material-symbols-outlined text-sm">error</span>
            {{ pinError }}
          </span>
        </div>

        <button
          (click)="setup()"
          [disabled]="loading || pin.length !== 6 || confirmPin.length !== 6"
          class="btn-large-brand"
        >
          <span *ngIf="loading">Securing Vault...</span>
          <span *ngIf="!loading">Enable Encryption</span>
        </button>
      </div>

      <!-- Step 4: DONE -->
      <div *ngIf="step === 'DONE'" class="step-done">
        <div class="success-icon">
          <span class="material-symbols-outlined">check</span>
        </div>
        <h3>All Set!</h3>
        <p>Your personal vault is encrypted and active.</p>
        <button (click)="closeModal()" class="btn-large-secondary">
          Close
        </button>
      </div>
    </div>
  </div>
</div>
